import React from "react";
import {
  Box,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Typography,
  useScrollTrigger,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ReplayRoundedIcon from "@mui/icons-material/ReplayRounded";

import Users from "./Users/Users";
import GlobalSearch from "../../../../components/Search";
import attachFileIcon from "../../../../styles/svg/attachment.svg";
import AttachmentBar from "../attachments";
import Archive from "./Archive";
import BoardName from "./BoardName";
import MilestoneSection from "../MilestoneSection";
import StatusDropDown from "./statusDropdown/StatusDropDown";
import MilestoneTabs from "../MilestoneSection/MilestoneTabs";
import { TooltipName } from "../../../../utils/Enums";
import DrawerGlobalComp from "../../../../components/Drawer";
import { CustomButton } from "../../../../components/Button/Button";
import ViewToggle from "./components/ViewToggle";
import UserFilter from "./components/UserFilter";
import MobileActions from "./components/MobileActions";
import CustomMenu from "../../../../components/Menu";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import SidebarListItem from "../../../dashboard/components/SidebarListItem";
import EstimatedFilter from "./EstimatedFilter";
import worklogIcon from "../../../../styles/svg/updated_see_worklogs_icon.svg";
import feedIcon from "../../../../styles/svg/updated_feed_icon.svg";
import boardDocumentIcon from "../../../../styles/svg/board_document_icon.svg";
import BoardDocument from "./BoardDocument";
import "./boardStyle.scss";
import { isAdmin } from "../../../../utils/constants";
import { normalizeBoardHeaderData } from "./hooks/boardHeaderUtils";
import {
  useBoardHeaderState,
} from "./hooks/useBoardHeaderState";

function BoardHeader({ boardName, boardId, ownerId, workflowId, setLoading }) {
  const trigger = useScrollTrigger();
  const board = normalizeBoardHeaderData(boardName);
  const {
    attachmentDialog,
    boardList,
    cachedBoard,
    canAccessBoardHeaderMenu,
    changeBoardAnchorEl,
    clearFilters,
    filterDrawer,
    handleCloseChangeBoard,
    handleCloseFilterDrawer,
    handleFeedsNavigate,
    handleOpenChangeBoard,
    handleOpenSearchField,
    handleSearchCancel,
    handleSearchChange,
    handleWorklogsNavigate,
    inputValue,
    isMobile,
    isPermission,
    location,
    milestone,
    openChangeBoard,
    openSearchField,
    paramsWorklogs,
    searchParams,
    selectedUsers,
    setAttachmentDialog,
    setFilterDrawer,
    setParamsWorklogs,
    setSearchParams,
    setShowSummary,
    showGridView,
    showSummary,
    toggleDrawer,
  } = useBoardHeaderState();

  return (
    <>
      {openSearchField ? (
        <Grid
          container
          item
          xs={12}
          className="remove-container-width fixed-ui"
          justifyContent={"center"}
          alignItems={"center"}
        >
          <GlobalSearch
            placeholder={"Search..."}
            searchText={inputValue}
            handleChange={handleSearchChange}
            onCancel={handleSearchCancel}
            showCancel={true}
            fullWidth={true}
          />
        </Grid>
      ) : (
        <Grid
          container
          item
          xs={12}
          className={`remove-container-width fixed-ui ${
            isMobile ? "mobile-board-header-container" : ""
          }`}
          sx={{ top: trigger ? "0px" : isMobile ? "50px" : "" }}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Grid
            item
            xs={6}
            md={12}
            lg={4}
            className="d-flex align-items-center"
          >
            {board && <BoardName boardName={boardName} />}
            {isMobile && (
              <KeyboardArrowDownIcon
                className="mobile-change-board-btn"
                onClick={handleOpenChangeBoard}
              />
            )}
          </Grid>
          <CustomMenu
            anchorEl={changeBoardAnchorEl}
            open={openChangeBoard}
            className="mobile-change-board-menu"
            onClose={handleCloseChangeBoard}
          >
            {boardList
              .sort((boardA, boardB) =>
                boardA?.board_name?.localeCompare(boardB?.board_name)
              )
              .map((listBoard) => (
                <CustomMenuItem key={listBoard?.board_id}>
                  <SidebarListItem board={listBoard} />
                </CustomMenuItem>
              ))}
          </CustomMenu>

          <Grid item xs={6} md={7} lg={8}>
            <div className="d-flex justify-content-end align-items-center">
              {isMobile ? (
                <>
                  <MobileActions
                    setAttachmentDialog={setAttachmentDialog}
                    attachmentDialog={attachmentDialog}
                    setFilterDrawer={setFilterDrawer}
                    openSearchField={openSearchField}
                    handleOpenSearchField={handleOpenSearchField}
                  />
                  {canAccessBoardHeaderMenu && (
                    <Archive
                      isOwner={cachedBoard?.is_owner}
                      isAdmin={isAdmin()}
                      boardId={boardId}
                    />
                  )}
                </>
              ) : (
                <Stack spacing={1} direction="row">
                  <UserFilter
                    selectedUsers={selectedUsers}
                    clearFilters={clearFilters}
                  />

                  <Users
                    boardName={boardName}
                    boardId={boardId}
                    ownerId={ownerId}
                  />
                  {!showGridView &&
                    !location.pathname.includes("/feeds/") &&
                    paramsWorklogs === "false" && (
                      <StatusDropDown workflowId={workflowId} />
                    )}
                  <ViewToggle
                    setLoading={setLoading}
                    setParamsWorklogs={setParamsWorklogs}
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                  />

                  <Tooltip title={TooltipName.BOARD_PAGE.WORKLOGS}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={handleWorklogsNavigate}
                    >
                      <img
                        src={worklogIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>
                  {isPermission && (
                    <Tooltip title={TooltipName.BOARD_PAGE.FEEDS}>
                      <IconButton
                        className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                        onClick={handleFeedsNavigate}
                      >
                        <img
                          src={feedIcon}
                          className="header-filter-icon"
                          alt="not found"
                        />
                      </IconButton>
                    </Tooltip>
                  )}

                  <Tooltip title={TooltipName.BOARD_PAGE.BOARD_DOCUMENT}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={() => setShowSummary(true)}
                    >
                      <img
                        src={boardDocumentIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>

                  <Tooltip title={TooltipName.BOARD_PAGE.ADD_ATTACHMENTS}>
                    <IconButton
                      className="white-button attach-btn board-header-attach-btn board-header-tooltip-btn"
                      onClick={() =>
                        setAttachmentDialog((previousState) => ({
                          ...previousState,
                          right: true,
                        }))
                      }
                    >
                      <img
                        src={attachFileIcon}
                        className="header-filter-icon"
                        alt="not found"
                      />
                    </IconButton>
                  </Tooltip>
                  {!location.pathname.includes("feeds") && (
                    <>
                      <GlobalSearch
                        placeholder={"Search..."}
                        searchText={inputValue}
                        handleChange={handleSearchChange}
                      />
                      <EstimatedFilter />
                    </>
                  )}
                  {canAccessBoardHeaderMenu && (
                    <Archive
                      isOwner={cachedBoard?.is_owner}
                      isAdmin={isAdmin()}
                      boardId={boardId}
                    />
                  )}
                </Stack>
              )}
            </div>
          </Grid>
          <MilestoneTabs
            boardName={boardName}
            isOwner={cachedBoard?.is_owner}
          />
          {milestone && <MilestoneSection boardName={boardName} />}
        </Grid>
      )}
      {attachmentDialog && (
        <AttachmentBar state={attachmentDialog} toggleDrawer={toggleDrawer} />
      )}
      {filterDrawer && (
        <DrawerGlobalComp
          open={filterDrawer}
          setOpen={setFilterDrawer}
          className="mobile-board-filter-drawer"
        >
          <Box pt={1} pl={1} className="mobile-board-filter-drawer-header">
            <Stack direction="row" justifyContent={"space-between"}>
              <Typography fontWeight={600}>Filter By</Typography>

              <CustomButton
                size="small"
                onClick={
                  selectedUsers?.length ? clearFilters : handleCloseFilterDrawer
                }
                startIcon={selectedUsers?.length ? <ReplayRoundedIcon /> : ""}
                className={`capitalize mobile-reset-btn`}
              >
                {selectedUsers?.length ? "Reset" : ""}
              </CustomButton>
            </Stack>
          </Box>
          <Box p={1} className="mobile-board-filter-drawer-users-list">
            <p className="mobile-filter-title">By Users</p>
            <Users
              boardName={boardName}
              boardId={boardId}
              ownerId={ownerId}
              setDrawerClose={() => setFilterDrawer(false)}
            />
          </Box>
        </DrawerGlobalComp>
      )}
      {showSummary && (
        <BoardDocument
          boardName={board?.board_name}
          setShowSummary={setShowSummary}
          showSummary={showSummary}
          boardId={boardId}
          isPermission={isPermission}
        />
      )}
    </>
  );
}

export default BoardHeader;
